<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='6'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">如何询价</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content">1</div>
                  </div>
                  <div class="n_right_head">
                    <p>第一步</p>
                    <span>从首页点击【平台询价】 进入其页面</span>
                  </div>
                </div>
                <div class="n_content">
                  <img src="../../assets/images/xjpt.jpg" alt="第一步">
                </div>
              </div>
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content">2</div>
                  </div>
                  <div class="n_right_head">
                    <p>第二步</p>
                    <span>上传文件，生成报价单</span>
                  </div>
                </div>
                <div class="n_content">
                  <img src="../../assets/images/xjsc.jpg" alt="第二步">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'

export default {
  name: 'Howinqu',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
</style>



// WEBPACK FOOTER //
// src/view/help/howinqu.vue